<template>
  <div class="pointcard-container">
    <form class="o-mcds-form">
      <div class="c-chnl-form_group">
        <span class="c-chnl-form_type">卡號：</span>
        <div class="c-chnl-form_ctrl">
          <input
            type="text"
            v-model="pin"
            name="card_id"
            placeholder="請輸入卡號"
            class="c-chnl-form_ipt"
          />
        </div>
      </div>
      <div class="c-chnl-form_group">
        <span class="c-chnl-form_type">密碼：</span>
        <div class="c-chnl-form_ctrl">
          <input
            type="password"
            v-model="serial"
            name="card_pwd"
            placeholder="請輸入密碼"
            class="c-chnl-form_ipt"
          />
        </div>
      </div>
      <div class="c-qr">
        <button
          @click="pay"
          :class="{
            active: submiteState == SUBMIT_ABLE,
            sleep: submiteState !== SUBMIT_ABLE,
          }"
          class="c-qr_btn j-mcds-login-btn"
          type="button"
        >
          確認
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
const SUBMIT_ABLE = true;
export const NEED_PIN_ONLY = 1;
export const NEED_PIN_SERIAL = 2;
export default {
  data() {
    return {
      pin: '',
      serial: '',
      SUBMIT_ABLE,
      NEED_PIN_SERIAL,
    };
  },
  props: ['amount', 'type'],
  computed: {
    languages() {
      return this.$store.state.store.languages;
    },
    submiteState() {
      if (
        this.pin == '' ||
        (this.type == NEED_PIN_SERIAL && this.serial == '')
      ) {
        return !SUBMIT_ABLE;
      }
      return SUBMIT_ABLE;
    },
  },
  methods: {
    pay() {
      if (this.submiteState == SUBMIT_ABLE) {
        this.$emit('payWidthPointCard', {
          pin: this.pin,
          serial: this.serial,
        });
      } else {
        this.showDialogTw('input-tips');
      }
    },
    ...mapMutations(['showDialogTw']),
  },
};
</script>
